// Shared loading indicator — a thin ring with one bright arc rotating.
// Used inside buttons that are mid-action and for page-level fetches so
// every loading state in the app looks the same.

type Props = {
  size?: number;
  className?: string;
  label?: string;
};

export function Spinner({ size = 20, className = '', label = 'Chargement' }: Props) {
  return (
    <span
      role="status"
      aria-label={label}
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 10)) }}
      className={`inline-block rounded-full border-white/30 border-t-white animate-spin ${className}`}
    />
  );
}

// Centered variant for empty-state / page-level loading.
export function CenteredSpinner({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-8">
      <Spinner size={28} label={label} />
    </div>
  );
}
